import { useQuery } from '@apollo/client'
import GET_STRIPE_PLAN from 'components/api/queries/getStripePlan.gql'

/**
 * Returns stripe plan and loading state based on following logic:
 *  - If userInput.stripePlan is defined that will trump all and be returned
 *  - If there is no stripe plan defined in user input and the url query contains
 *    a stripe_plan_id then fetch stripePlan for that id and return it
 * @param {object} userInput
 */
const useStripePlan = ({ userInput, query }) => {
  const userSelectedStripePlan = userInput?.stripePlan
  const stripePlanIdFromUrl = query?.stripe_plan_id
  const isFetchStripeSkipped = userSelectedStripePlan || !stripePlanIdFromUrl
  const { data, loading } = useQuery(GET_STRIPE_PLAN, {
    variables: { stripePlanId: stripePlanIdFromUrl },
    skip: isFetchStripeSkipped,
  })
  const stripePlan = isFetchStripeSkipped ? userSelectedStripePlan : data?.stripe_plan
  return { data: stripePlan, loading }
}

export default useStripePlan
